import type { RecommendedGroup } from 'src/app/pages/starterDashboardV2/shared/types';

import type { GroupData } from './types';

export function mapRecommendedGroupToGroupData(group: RecommendedGroup, platform: 'facebook' | 'reddit'): GroupData {
	const { name, metadata } = group;
	const { memberCount, imageUrl } = metadata;

	return {
		name,
		followers: memberCount,
		platform,
		iconUrl: imageUrl ?? undefined,
	};
}
